import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import Container from "components/container";
import SectionHeading from "components/sectionHeading";

const MTContainer = styled(Container)`
  ${tw`mt-4`}
`;
const HalfColCentered = styled.div`
  ${tw`text-center w-full mx-auto md:w-1/2 px-[15px]`}
`;

const Support = () => (
  <MTContainer>
    <SectionHeading>Frequently Asked Questions</SectionHeading>
    <br />
    <HalfColCentered>
      <ul>
        <li style={{ textAlign: "left" }}>
          <strong>Who can I contact for help with an order?</strong>
          <p>
            Email us at{" "}
            <a href="mailto:support@dwellsocial.zendesk.com">
              support@dwellsocial.com
            </a>{" "}
            with any questions that you may have.
          </p>
        </li>
        <li style={{ textAlign: "left" }}>
          <strong>When do I receive pickup instructions?</strong>
          <p>
            We will send you reminders the day before and day of pickup with a
            specific location and time, as details are finalized.
          </p>
        </li>
        <li style={{ textAlign: "left" }}>
          <strong>When do I receive pickup instructions?</strong>
          <p>
            We will send you reminders the day before and day of pickup with a
            specific location and time, as details are finalized.
          </p>
        </li>
      </ul>
    </HalfColCentered>
  </MTContainer>
);

export default Support;
